module.exports = __webpack_public_path__ + "static/media/SM-MT2-TRIAL.044d0d9b.mp3";